//it meant to be "add global tag" but it ended to be "add tag" and the name stuck with us
//or edit
(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("AddGlobalTagController", AddGlobalTagController);

    AddGlobalTagController.$inject = ['$scope', 'modalData', 'onHide', 'hFormsService', '$filter', 'hUser'];

    function AddGlobalTagController ($scope, modalData, onHide, hFormsService, $filter, hUser) {

        var self = this;

        var brandId = modalData.brand_id;
        self.gpLevel = modalData.gpLevel || hUser.isTopLevelContext();
        self.modalData = modalData;

        var init = function () {
            self.loading = false;
            var addGlobalTagForm = hFormsService.getForm('AddGlobalTagForm');
            self.addGlobalTagForm = new addGlobalTagForm($scope, 'add-global-tag-form');
            self.addGlobalTagForm.loadData(self.modalData);
            self.addGlobalTagForm.setBrandId(brandId);
        };

        init();

        self.hideModal = function (val) {
            self.modalData = {};
            self.loading = false;
            onHide && onHide(val);
            $scope.$hide();
        };

        self.delete = function () {
            self.loading = true;
            self.addGlobalTagForm.deleteTag()
                .then(function () {
                    self.hideModal(true);
                })
                .catch(function (err) {
                    console.error(err);
                })
                .finally(function () {
                    self.loading = false;
                });
        };

        self.save = function () {
            self.loading = true;
            self.addGlobalTagForm.save()
                .then(function () {
                    self.hideModal(true);
                })
                .finally(function () {
                    self.loading = false;
                });
        };

        self.isEditMode = function () {
            return self.modalData.tag && self.modalData.tag.id;
        };
    }
})();
